import { styled } from '@shared/ui/styled';
import { getPatientInitials } from '../lib/getPatientInitials';

const Root = styled('div')(() => ({
  width: 52,
  height: 52,
  borderRadius: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  background: 'linear-gradient(135deg, var(--qhs-primary), var(--qhs-brand))',
  color: '#fff',
  fontFamily: 'var(--qhs-font-head)',
  fontWeight: 700,
  fontSize: 17,
  letterSpacing: '0.5px',
}));

/**
 * Identity avatar for the InfoPane Patient sub-page. Renders the
 * patient's initials over a brand gradient. Returns "?" for
 * anonymous / missing payloads so the surface never collapses.
 */
const Avatar = ({ patient }) => <Root>{getPatientInitials(patient)}</Root>;

export default Avatar;
